import { jsx as _jsx } from "react/jsx-runtime";
import { generateViewsComponent } from "../../../../helpers/views.js";
import useInput from "../../../../hooks/forms/useInput/index.js";
import LocationMobileView from "./views/mobile/index.js";
export const Location = generateViewsComponent(LocationMobileView);
export const FormLocation = (props)=>{
    const { origin , destination , originValidate , destinationValidate  } = props;
    const { isHiddenRequired: _isHiddenRequiredOrigin , ...restOrigin } = origin;
    const { isHiddenRequired: _isHiddenRequiredDestination , ...restDestination } = destination;
    const originField = useInput({
        ...origin,
        validate: originValidate
    });
    const destinationField = useInput({
        ...destination,
        validate: destinationValidate
    });
    const finalOrigin = {
        ...restOrigin,
        ...originField.field,
        error: originField.error,
        hasError: originField.hasError,
        label: originField.label
    };
    const finalDestination = {
        ...restDestination,
        ...destinationField.field,
        error: destinationField.error,
        hasError: destinationField.hasError,
        label: destinationField.label
    };
    return /*#__PURE__*/ _jsx(Location, {
        ...props,
        origin: finalOrigin,
        destination: finalDestination,
        error: originField.error ?? destinationField.error,
        hasError: originField.hasError || destinationField.hasError
    });
};
export default Location;

//# sourceMappingURL=index.js.map